import { Controller } from "@hotwired/stimulus";

const IFRAME_ALLOW = [
  "camera *",
  "microphone *",
  "geolocation *",
  "clipboard-read *",
  "clipboard-write *",
  "gyroscope *",
  "accelerometer *",
  "magnetometer *",
  "ch-ua-platform-version *",
  "ch-ua-model *",
  "ch-ua-full-version *"
].join("; ");

export default class extends Controller {
  static values = {
    onboardingUrl: String,
    redirectUrl: String,
    widgetId: String,
    sidebarMenuEnabled: Boolean
  }

  connect() {
    this.observeIframeInsertion();
    this.initWidget();
  }

  disconnect() {
    this.iframeObserver?.disconnect();
  }

  observeIframeInsertion() {
    const container = document.getElementById(this.widgetIdValue);
    if (!container) return;

    this.iframeObserver = new MutationObserver(() => {
      const iframe = container.querySelector("iframe");
      if (!iframe) return;

      this.iframeObserver.disconnect();
      iframe.setAttribute("allow", IFRAME_ALLOW);
      iframe.setAttribute("src", iframe.getAttribute("src") ?? "");
    });
    this.iframeObserver.observe(container, { childList: true });
  }

  initWidget() {
    LemonwayWidget.init(
      this.onboardingUrlValue,
      this.widgetIdValue,
      {
        lang: "fr",
        isSidebarMenuEnabled: this.hasSidebarMenuEnabledValue ? this.sidebarMenuEnabledValue : true,
        onMyAccount: () => this.redirectToNextStep(false, 4000),
        onFinish: () => this.redirectToNextStep(true, 10000),

        onPageChange: () => {
          const scroller = this.element.closest(".main-online-onboarding");
          (scroller?.scrollTo ? scroller : window).scrollTo({ top: 0, behavior: "smooth" });
        }
      }
    );
  }

  redirectToNextStep(success = false, delay = 0) {
    const url = new URL(this.redirectUrlValue);

    if (success) {
      url.searchParams.set("status", "under_analysis");
    }

    setTimeout(() => {
      window.location.replace(url);
    }, delay);
  }
}
